"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebVitalMonitor = exports.ELEMENT_TIMING_FMP = void 0;
const react_1 = require("react");
const attribution_1 = require("web-vitals/attribution");
const utils_1 = require("./utils");
const fmp_1 = require("./fmp");
var fmp_2 = require("./fmp");
Object.defineProperty(exports, "ELEMENT_TIMING_FMP", { enumerable: true, get: function () { return fmp_2.ELEMENT_TIMING_FMP; } });
const WebVitalMonitor = () => {
    const isFirst = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(() => {
        if (isFirst.current) {
            isFirst.current = false;
            (0, attribution_1.onLCP)((0, utils_1.buildWebVitalCallback)('lcp', ({ value, rating, navigationType, attribution }) => ({
                value,
                rating,
                navigation_type: navigationType,
                element: attribution.element,
                element_url: attribution.url,
                time_to_first_byte: attribution.timeToFirstByte,
                resource_load_delay: attribution.resourceLoadDelay,
                resource_load_time: attribution.resourceLoadTime,
                element_render_delay: attribution.elementRenderDelay,
                resource_transfer_size: attribution.lcpResourceEntry?.transferSize || 0,
            })));
            (0, attribution_1.onCLS)((0, utils_1.buildWebVitalCallback)('cls', ({ value, rating, navigationType, attribution }) => ({
                value,
                rating,
                navigation_type: navigationType,
                shift_target: attribution.largestShiftTarget,
                shift_time: attribution.largestShiftTime,
                load_state: attribution.loadState,
            })));
            (0, attribution_1.onINP)((0, utils_1.buildWebVitalCallback)('inp', ({ value, rating, navigationType, attribution }) => ({
                value,
                rating,
                navigation_type: navigationType,
                event_target: attribution.eventTarget,
                event_type: attribution.eventType,
                event_time: attribution.eventTime,
                load_state: attribution.loadState,
            })));
            (0, attribution_1.onFID)((0, utils_1.buildWebVitalCallback)('fid', ({ value, rating, navigationType, attribution }) => ({
                value,
                rating,
                navigation_type: navigationType,
                event_target: attribution.eventTarget,
                event_type: attribution.eventType,
                event_time: attribution.eventTime,
                load_state: attribution.loadState,
            })));
            (0, attribution_1.onFCP)((0, utils_1.buildWebVitalCallback)('fcp', ({ value, rating, navigationType, attribution }) => ({
                value,
                rating,
                navigation_type: navigationType,
                time_to_first_byte: attribution.timeToFirstByte,
                first_byte_to_fcp: attribution.firstByteToFCP,
            })));
            (0, attribution_1.onTTFB)((0, utils_1.buildWebVitalCallback)('ttfb', ({ value, rating, navigationType, attribution }) => ({
                value,
                rating,
                navigation_type: navigationType,
                waiting_time: attribution.waitingTime,
                dns_time: attribution.dnsTime,
                connection_time: attribution.connectionTime,
                request_time: attribution.requestTime,
            })));
            (0, fmp_1.monitorFMP)();
        }
    }, []);
    return null;
};
exports.WebVitalMonitor = WebVitalMonitor;
